import * as React from "react";
import {FormBuilderOptions} from "./FormBuilder.options";
import { FBRow} from "./FBRow";
import {RefArray} from "shared/utilities/react/RefArray";
import {RowDesigner} from "../../ProductFieldBuilder/Designer/RowDesigner";
import {FBRowOptions} from "./FBRow.Options";
import {Price} from "../Utilities/Components/Price";
import {PriceManager} from "../Utilities/Managers/PriceManager/PriceManager";
import {FormBuilder} from "./FormBuilder";
import {ContainerDataRetriever, FormBuilderModel} from "FormBuilder/Core/FormBuilder.Model";


export class TotalContainer extends React.Component<TotalContainerProps, TotalContainerState> {

    constructor(props: TotalContainerProps) {
        super(props);
        this.state = {};

        props.FormBuilder.PriceManager.TotalUpdated.Subscribe(this,x=>this.forceUpdate());
    }


    public render() {
        let formBuilder=this.props.FormBuilder.ContainerManager.GetRootContainer() as FormBuilderModel;
       return (
           <div className={'rnTotalBox'}>
               <label>{formBuilder.Options.OptionsAmountLabel}</label>
               <Price Amount={this.props.FormBuilder.PriceManager.GetOptionsTotal()}/>
               <label>{formBuilder.Options.FinalTotalLabel}</label>
               <Price Amount={this.props.FormBuilder.PriceManager.GetGrandTotal()}/>
           </div>
       )
    }


}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
export interface TotalContainerProps {
    FormBuilder:ContainerDataRetriever;
}

export class TotalContainerState {

}


//#endregion "My Region"


/*

import {FormBuilderOptions} from "./FormBuilder.options";
import {FBRow} from "./FBRow";
import {FBFieldBaseOptions} from "../Fields/Core/FieldBase.options";
import {FieldFactory} from "../FieldFactory";
import {FBRowOptions} from "./FBRow.Options";
import * as React from "react";


export class FormBuilder extends React.Component<state,prop>{
    public Container:HTMLDivElement;
    public Options:FormBuilderOptions;
    public Factory:FieldFactory;
    public Rows:FBRow[];

    public Initialize(options:FormBuilderOptions)
    {
        this.InitializeFactory();
        this.Rows=[];
        this.Options=options;
        for(let row of this.Options.Rows)
        {
            let rowInstance=this.GetRowInstance();
            rowInstance.Initialize(this,row);
            this.Rows.push(rowInstance);
        }
        return this;
    }

    AppendTo(DesignerBuilderContainer: HTMLDivElement) {
        this.Container=DesignerBuilderContainer;
        this.Container.innerHTML='';
        this.Container.classList.add('WooFieldForm');

        for(let row of this.Rows)
        {
            row.AppendElement();
        }
    }

    protected GetRowInstance() {
        return new FBRow();
    }

    AddField(field: FBFieldBaseOptions) {
        let row=this.GetRowInstance();
        let rowOptions=new FBRowOptions().Merge({Columns:[{Field:field}]});
        row.Initialize(this,rowOptions);
        this.Rows.push(row);
        row.AppendElement();

    }

    public InitializeFactory(){
        this.Factory=new FieldFactory();
    }
}


 */